const SKIP_TOKEN_SUBSTRINGS = ['portal-settings', '/communities/analytics/track-event'] as const

/** Public legal-page and app-banner reads. Other branded-app routes stay authenticated. */
const PUBLIC_BRANDED_APP_READS = /\/branded-app\/[^/]+\/(?:customization|metadata)(?:\?|$)/u

export const shouldSkipAuthToken = (url: string, method = 'GET'): boolean => {
  if (SKIP_TOKEN_SUBSTRINGS.some(endpoint => url.includes(endpoint))) return true
  return method.toUpperCase() === 'GET' && PUBLIC_BRANDED_APP_READS.test(url)
}
